import { PortState } from './reducer';

export const getPorts = (state: any) => state.PortManager?.ports || [];